import React, { useContext } from "react";

import { PrivateRoutesContext } from "app/PrivateRoutesContext";

function SpaceCoLab (props) {
    const { userInfo } = useContext(PrivateRoutesContext);
    console.log('userinfo:', userInfo)

    return userInfo?.companyDetails?.spaceCoLabUri ?
    <iframe title="CoLab" width="1400" height="860" src={userInfo.companyDetails.spaceCoLabUri} frameBorder="0" scrolling="no" allowfullscreen></iframe>
    : <></>
}
export default SpaceCoLab;